import KTImageInput from 'general/components/OtherKeenComponents/FileUpload/KTImageInput';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useState } from 'react';

ImageView.propTypes = {
  name: PropTypes.string.isRequired,
  path: PropTypes.string,
  item: PropTypes.oneOfType([PropTypes.instanceOf(File), PropTypes.string]),
  onRemove: PropTypes.func,
  fileName: PropTypes.string,
  showFileName: PropTypes.bool,
  contractMedia: PropTypes.bool,
};

const getAttachmentThumbnail = (ext) => {
  const e = ext?.toLowerCase();
  if (['doc', 'docx'].includes(e)) return require('assets/images/TMT/attachment/docx.png');
  if (e === 'pdf') return require('assets/images/TMT/attachment/pdf.png');
  if (['ppt', 'pptx'].includes(e)) return require('assets/images/TMT/attachment/ppt.png');
  if (['xls', 'xlsx', 'csv'].includes(e)) return require('assets/images/TMT/attachment/xls.png');
  return require('assets/images/TMT/attachment/file.png');
};

function ImageView(props) {
  // MARK: ---- PROPERTIES ----
  const { name, path, item, onRemove, fileName, showFileName = true, contractMedia = false } = props;

  const resolveRemoteUrl = (rawPath) => {
    if (!rawPath) return '';
    return Utils.buildAuthenticatedMediaUrl(rawPath, { useContractMedia: contractMedia });
  };
  const fileExt = Utils.getFileExt(path);
  const isImageFile = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(fileExt?.toLowerCase());

  const image = isImageFile
    ? item instanceof File
      ? URL.createObjectURL(item)
      : resolveRemoteUrl(item ?? path)
    : item
      ? getAttachmentThumbnail(fileExt)
      : AppResource.icons.fileType[`icFileType${fileExt}`] ?? AppResource.icons.fileType.icFileTypeUNKNOWN;

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const lightboxSrc = item instanceof File ? URL.createObjectURL(item) : resolveRemoteUrl(path);

  const handleOpenFile = () => {
    if (item instanceof File) {
      Utils.openFileOrDownload({ file: item });
      return;
    }
    Utils.openFileOrDownload({
      url: path,
      fileName: fileName ?? path,
      useContractMedia: contractMedia,
    });
  };

  return (
    <div className="d-flex flex-column gap-1">
      {isImageFile ? (
        <KTImageInput
          name={name}
          value={image}
          aspectRatio="16/9"
          backgroundSize="contain"
          defaultImage={AppResource.icons.avatar.carDefault}
          additionalInputClassName="w-100 bg-white"
          disabled={true}
          editable={false}
          removable={Utils.isValid(onRemove)}
          onForceRemoveFile={onRemove}
          onPress={() => setLightboxOpen(true)}
        />
      ) : (
        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
          <div
            className="cursor-pointer d-flex align-items-center justify-content-center"
            style={{
              border: '1px solid #DBDFF1',
              borderRadius: '0.42rem',
              backgroundColor: 'rgba(255,255,255,0.3)',
              padding: 5,
              aspectRatio: '16/9',
            }}
            onClick={handleOpenFile}
          >
            <img src={image} alt={fileName ?? path} style={{ width: '50%', height: '100%', objectFit: 'contain', display: 'block' }} />
          </div>
          {Utils.isValid(onRemove) && (
            <span
              className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
              style={{ position: 'absolute', right: -10, bottom: -5 }}
              onClick={(e) => { e.stopPropagation(); onRemove(); }}
            >
              <i className="ki ki-bold-close icon-xs text-muted" />
            </span>
          )}
        </div>
      )}
      <div>
        {showFileName && (
          <span
            className="text-ellipsis-2-lines"
            style={UIHelper.buildFontStyle('500', '12px', AppColors.gray[800])}
          >
            {fileName ?? path}
          </span>
        )}
      </div>

      {lightboxOpen && (
        <div
          onClick={() => setLightboxOpen(false)}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            background: 'rgba(0,0,0,0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={lightboxSrc}
            alt={fileName ?? path}
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              objectFit: 'contain',
              borderRadius: '8px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
            }}
          />
          <button
            onClick={() => setLightboxOpen(false)}
            style={{
              position: 'absolute',
              top: '16px',
              right: '24px',
              background: 'transparent',
              border: 'none',
              color: '#fff',
              fontSize: '32px',
              cursor: 'pointer',
              lineHeight: 1,
            }}
          >
            &times;
          </button>
        </div>
      )}
    </div>
  );
}

export default ImageView;
